// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1NXNK","disabled":"FileBtn_disabled__31Lhg","warn":"FileBtn_warn__1MZZt","fade":"FileBtn_fade__3VtRP"};